var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"padless":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }